const layoutState = new WeakMap();
const mobileQuery = window.matchMedia('(max-width: 615px)');

const getMaxColumns = (list) => {
  const value = Number.parseInt(getComputedStyle(list).getPropertyValue('--catalog-overview-columns'), 10);

  return Number.isFinite(value) && value > 0 ? value : 1;
};

const getRowLengths = (count, maxColumns) => {
  const rows = Math.ceil(count / maxColumns);
  const columns = Math.floor(count / rows);
  const longer = count % rows;
  const lengths = [];
  const shortRowLast = maxColumns === 2;

  for (let row = 1; row <= rows; row += 1) {
    const isLonger = shortRowLast ? row <= longer : row > rows - longer;

    lengths.push(isLonger ? columns + 1 : columns);
  }

  return lengths;
};

const clearItemColumns = (list) => {
  Array.from(list.children).forEach((item) => {
    item.style.removeProperty('--catalog-overview-columns');
  });
};

const layoutCatalogOverview = (list) => {
  const items = Array.from(list.children);

  if (mobileQuery.matches) {
    if (layoutState.get(list) === 'mobile') {
      return;
    }

    layoutState.set(list, 'mobile');
    clearItemColumns(list);
    return;
  }

  const maxColumns = getMaxColumns(list);
  const state = `${maxColumns}:${items.length}`;

  if (layoutState.get(list) === state) {
    return;
  }

  layoutState.set(list, state);

  const lengths = getRowLengths(items.length, maxColumns);
  let index = 0;

  lengths.forEach((length) => {
    for (let column = 0; column < length; column += 1) {
      items[index].style.setProperty('--catalog-overview-columns', String(length));
      index += 1;
    }
  });
};

const initCatalogOverview = () => {
  const lists = document.querySelectorAll('[data-catalog-overview]');

  if (!lists.length) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCatalogOverview, {once: true});
    }

    return;
  }

  const update = () => {
    lists.forEach((list) => layoutCatalogOverview(list));
  };

  update();
  mobileQuery.addEventListener('change', update);

  lists.forEach((list) => {
    const resizeObserver = new ResizeObserver(update);

    resizeObserver.observe(list);

    const mutationObserver = new MutationObserver(update);

    mutationObserver.observe(list, {childList: true});
  });
};

export {initCatalogOverview};
